<template>
  <div>
    <div class="" v-if="poster">
      <div class="col">
        <div class="alert alert-primary">

          <div class="row d-flex">
            <div class="col-9 my-auto">
              <h6><div class="my-auto" v-html="poster.title"></div></h6>
              <div class="small"><span v-if="poster.presentation_code">Pres. Code: {{ poster.presentation_code }}&nbsp;</span></div>
            </div>
            <div class="col-3 d-flex float-right" >
              <icon :icon="['fal', 'calendar-xmark']" class="text-danger"/>&nbsp;Deadline: {{submissions.find(submission => submission.id === poster.setting_submission_id).show_stop_date | moment(wording[0].home.dateformat)}}
            </div>
          </div>
        </div>
      </div>
      <div v-if="$route.params.pageid && $route.params.pageid > 0">
        <entitegenerator :entities="entities" :values="poster"
                         :system="{main: 'submission', action: 'create'}"
                         :error="validation.errors"
                         :language="language"
                         mode="formular"></entitegenerator>
      </div>
      <div class="row mt-4">
        <div class="col d-flex">
          <button type="button" class="btn btn-info me-auto" v-if="!processing.dynamicdata"
                  v-on:click="saveAndNext(previousSite(getCurrentPages(poster.setting_submission_id), $route.params.pageid))">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            Back
          </button>
          <ProcessingButton class="me-auto" v-if="processing.dynamicdata"></ProcessingButton>
          <button type="button" class="btn btn-success mx-auto" v-on:click="saveAndNext(false)"
                  v-if="!processing.dynamicdata">
            <icon :icon="['fal', 'floppy-disk']" size="lg"/>&nbsp;Save
          </button>
          <ProcessingButton class="mx-auto" v-if="processing.dynamicdata"></ProcessingButton>
          <button type="button" class="btn btn-info float-end ms-auto"
                  v-if="hasNextSite(getCurrentPages(poster.setting_submission_id), $route.params.pageid) && !processing.dynamicdata"
                  v-on:click="saveAndNext(nextSite(getCurrentPages(poster.setting_submission_id), $route.params.pageid))">
            Next
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
          <ProcessingButton class="ms-auto" v-if="processing.dynamicdata"></ProcessingButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex'
import entitegenerator from 'entite-generator';

export default {
  components: {
    entitegenerator
  },
  data() {
    return {
      noSaveNext: null,
    };
  },
  computed: {
    ...mapState([
      'poster', 'wording', 'processing', 'validation', 'settings', "language",'submissions',
    ]),
    ...mapGetters([
      'getCurrentPages', 'getCurrentPageById'
    ]),
    entities: function () {
      return this.$store.getters.getCurrentPageById(Number(this.$route.params.pageid)).entity;
    },
  },
  methods:
      {
        ...mapActions(['PUT_POSTER', 'VALIDATE_TARGET']),
        async saveAndNext(target) {
          this.noSaveNext = target;
          this.processing.dynamicdata = true;

          await this.PUT_POSTER(this.$route.params.id).then((result) => {
            this.$noty.success(this.wording[0].notify.save_success);
            this.processing.dynamicdata = false;
            if (target !== false) {
              this.next(target);
            }
          }).catch((error) => {
            this.$noty.error(this.wording[0].notify.save_not_success);
            this.processing.dynamicdata = false;
          });

          //Das obere is hier mit drin..

          // if ((this.settings.validatebeforesave && this.settings.validatebeforesave === true)) {
          //   let isValid = false;
          //   let targetXHr = 'page/' + this.$route.params.pageid;
          //   let data = {template: {}, target: targetXHr};
          //   data.template = this.poster;
          //   await this.VALIDATE_TARGET(data).then((result) => {
          //     isValid = true;
          //     let validation = {"is_checked": true, "status": true, "errors": {}};
          //     this.$store.commit('SET_VALIDATION', {validation: validation});
          //   }).catch((error) => {
          //     this.noSaveNext = null;
          //     isValid = false;
          //     let validation = {"is_checked": true, "status": false, "errors": error.response.data};
          //     this.$store.commit('SET_VALIDATION', {validation: validation});
          //     this.$noty.error(this.wording[0].notify.save_not_success);
          //     this.$noty.error(this.wording[0].notify.validation_error);
          //     this.processing.dynamicdata = false;
          //   });
          //   if (isValid === false) return;
          //   await this.PUT_POSTER(this.$route.params.id).then((result) => {
          //     this.$noty.success(this.wording[0].notify.save_success);
          //     this.processing.dynamicdata = false;
          //     if (target !== false) {
          //       this.next(target);
          //     }
          //   }).catch((error) => {
          //     this.$noty.error(this.wording[0].notify.save_not_success);
          //     this.processing.dynamicdata = false;
          //   });
          // } else {
          //   if (this.validation.is_checked && !this.validation.status) {
          //     let targetXHr = '';
          //     let data = {template: {}, target: targetXHr};
          //     data.template = this.poster;
          //     await this.VALIDATE_TARGET(data).then((result) => {
          //       let validation = {"is_checked": true, "status": true, "errors": {}};
          //       this.$store.commit('SET_VALIDATION', {validation: validation});
          //     }).catch((error) => {
          //       console.log(error.respose);
          //       let validation = {"is_checked": true, "status": false, "errors": error.response.data};
          //       this.$store.commit('SET_VALIDATION', {validation: validation});
          //     });
          //   }
          //   await this.PUT_POSTER(this.$route.params.id).then((result) => {
          //     this.$noty.success(this.wording[0].notify.save_success);
          //     this.processing.dynamicdata = false;
          //     if (target !== false) {
          //       this.next(target);
          //     }
          //   }).catch((error) => {
          //     this.$noty.error(this.wording[0].notify.save_not_success);
          //     this.processing.dynamicdata = false;
          //   });
          // }
        },
        next(target) {
          this.$router.push(target);
        },
        nextCancel() {
          this.noSaveNext = null;
        },
      },
  created() {
  }
  , beforeRouteLeave(to, from, next) {
    if (!this.noSaveNext) {
      this.noSaveNext = to;
      this.saveAndNext(to);
    } else {
      this.noSaveNext = null;
      next()
    }
  }
  , beforeRouteUpdate(to, from, next) {
    if (!this.noSaveNext) {
      this.noSaveNext = to.path;
      this.saveAndNext(to.path);
    } else {
      this.noSaveNext = null;
      next()
    }
  }
}
</script>

<style scoped>

</style>
